import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {listShop} from "@/api/oms/shopee-order";

export default extend(dialog, {
	namespaced: true,
	state: {
		form: {},
		shopIdList: []
	},
	actions: {
		async afterOpenDialog({ dispatch, commit }, payload) {
			await wait(dispatch, 'sms.shopp-order.import-order', async function() {
				const response = await listShop();
				if (response.data) {
					commit('save', {
						shopIdList: response.data
					})
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/shopee-order/import-order.js